import { render, staticRenderFns } from "./Popup-add-funds.vue?vue&type=template&id=f6758ec2&"
import script from "./Popup-add-funds.vue?vue&type=script&lang=ts&"
export * from "./Popup-add-funds.vue?vue&type=script&lang=ts&"
import style0 from "./Popup-add-funds.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports